import { render, staticRenderFns } from "./pricedetail.vue?vue&type=template&id=437b344b&scoped=true&"
import script from "./pricedetail.vue?vue&type=script&lang=js&"
export * from "./pricedetail.vue?vue&type=script&lang=js&"
import style0 from "./pricedetail.vue?vue&type=style&index=0&id=437b344b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437b344b",
  null
  
)

export default component.exports